"use strict";
"use client";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorScheme = void 0;
const react_1 = require("react");
const get_color_scheme_1 = require("./get-color-scheme");
function useColorScheme() {
    const [colorScheme, setColorScheme] = (0, react_1.useState)(get_color_scheme_1.getColorScheme);
    (0, react_1.useEffect)(() => {
        const observer = new MutationObserver((mutations) => mutations.forEach(() => setColorScheme((0, get_color_scheme_1.getColorScheme)())));
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        return () => observer.disconnect();
    }, []);
    return colorScheme;
}
exports.useColorScheme = useColorScheme;
